export class AccountaymentModel {
  currency: string = "MXN";
  description: string = "Transferencia a cuenta CLABE solicitada en GANALOTTODO";
  awardTransactionsBeans: AwardTransactionsBeans[];
}

export class AwardTransactionsBeans {
  awardId: number;
	username: string;
	transferAmount: number;
	transferDescription: string;
	requestDate: string;
	lastUpdate: string;
	authorized: Boolean;
	paidOut: Boolean;
	payoutId: string;
	feeAmount: number;
  status: string;
  description: string;
  clabe: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/payments/account-payment.model.ts